import { ReactNode, JSX } from 'react';
import { AnalyticsContext } from '@src/contexts/analytics-context';
import { useInitDynatraceRum } from '@src/hooks/use-init-dynatrace-rum.hook';
import { useInitAnalytics } from '@src/hooks/use-init-analytics.hook';
import { useAnalyticsEvents } from '@src/hooks/use-analytics-events.hook';
import { ExtraData } from '@src/@types/analytics';

/**
 * Initializes SPA Analytics and Dynatrace RUM. Provides {@link AnalyticsContext}
 * to power the {@link useAnalytics} hook.
 */
export const AnalyticsProvider = ({
  analyticsRequested,
  analyticsExtraData,
  gtmParams,
  gtmContainerId,
  children,
}: {
  analyticsRequested: boolean;
  analyticsExtraData?: ExtraData;
  gtmParams: string;
  gtmContainerId: string;
  children: ReactNode;
}): JSX.Element => {
  const { analyticsInitialized, emitEvent } = useInitAnalytics(
    analyticsRequested,
    gtmParams,
    gtmContainerId,
    analyticsExtraData,
  );
  const { trackPageView, trackEvent, trackClick, trackImpression } =
    useAnalyticsEvents(emitEvent);

  useInitDynatraceRum();

  return (
    <AnalyticsContext.Provider
      value={{
        analyticsInitialized,
        trackPageView,
        trackClick,
        trackEvent,
        trackImpression,
      }}
    >
      {children}
    </AnalyticsContext.Provider>
  );
};
